import type {
  AnyFailure,
  PersonListResponse,
  PersonListSuccess,
} from "@b2bportal/air-booking-api";

import type { UpdatePassengerEvent } from "@checkout/states/common/PassengerInformation/events";
import { trackCheckoutEvent } from "@checkout/tracking/sink";
import { PassengerErrorModalTypes } from "@checkout/types";
import { fetchUserPassengers, updateUserPassenger } from "@hopper-b2b/api";
import { SAVE_TRAVELER } from "@hopper-b2b/types";
import type { PartialParentWithPassengerContext } from "../context";

export const updateUserPassengerService = (
  _context: PartialParentWithPassengerContext,
  event: UpdatePassengerEvent
) =>
  new Promise((resolve, reject) => {
    const { person, onUpdate, singleTravelerWorkflow } = event;
    updateUserPassenger({ person })
      .then(() => {
        trackCheckoutEvent({ eventName: SAVE_TRAVELER, properties: {} });
        fetchUserPassengers({}).then((response: PersonListResponse) => {
          if ((response as AnyFailure).Response === "Failure") {
            reject({
              type: PassengerErrorModalTypes.UpdatePassenger,
              data: (response as AnyFailure).errors,
            });
          } else {
            resolve({
              id: person.id,
              value: (response as PersonListSuccess).value,
              onUpdate,
              singleTravelerWorkflow,
            });
          }
        });
      })
      .catch((e) => {
        reject({
          type: PassengerErrorModalTypes.UpdatePassenger,
          data: e,
        });
      });
  });
